import { useCallback } from 'react';
import { api } from './api-core';
// import { LeanbotApi } from './leanbot-api';
// import { DistributorApi } from './distributor-api';
// import { StudentApi } from './student-api';
// import { TeacherApi } from './teacher-api';
// import { IPartner, PartnerApi } from './partner-api';
// import { SchoolApi } from './school-api';
// import { BadgeApi } from './badge';
// import { MissionApi } from './api-missions';
// export * from './leanbot-api';
// export * from './distributor-api';
// export * from './badge';
// export * from './api-missions';
import { UserApi } from './user-api';
import { DashboardApi } from './dashboard-api';
import { MyCourse } from './my-course';
import {Contest} from './contest';
import { MyTwinSpaceApi } from './my-twinspace-api';
import { MyCertificateApi } from './my-certificate-api';
import { MyOrderApi } from './my-order';
import { MyLeanbotApi } from './my-leanbot';
import { Chat } from './chat';
import { NotificationApi } from './notification-api';

// var coutryStatic:Promise<ICountry[]>;
export const apiRemote={
    ...UserApi,
    ...DashboardApi,
    ...MyCourse,
    ...Contest,
    ...MyTwinSpaceApi,
    ...MyCertificateApi,
    ...MyOrderApi,
    ...MyLeanbotApi,
    ...Chat,
    ...NotificationApi
}